import React, { Component } from 'react';
import _ from 'lodash';
import CustomLoader from '../common/Loader';
import * as Icon from 'react-feather';
import Select from "react-select";
import ListDataSource from '../admin/DataSource/ListDataSource';

class AddDataSource extends Component {
    constructor(props) {
        super(props);

        this.state = {
            preloadData: this.props.preloadData ? this.props.preloadData : undefined,
            saveSourceDS: '/api/v2/reports/updateReportConfig',
            loading: false,
        };
    }

    render() {
        const { saveSourceDS } = this.state;

        const loading = (<CustomLoader loading={this.state.loading} />);
        try {
            if (this.state.loading) { return loading; }
            else {
                return (
                    <React.Fragment>
                        {/* Builder DS */}
                        <div className="card mt-2">
                            <div className='card card-body'>
                                <h4 className='ml-3'>Builder</h4>
                                <br />
                                <ListDataSource key={saveSourceDS} compID='reportBuilder' Project_ID={9} Report_ID={1} saveSource={saveSourceDS} />
                            </div>
                        </div>
                        {/* Viewer DS */}
                        <div className='card card-body mt-4'>
                            <h4 className='ml-3'>Viewer</h4>
                            <br />
                            <ListDataSource key={saveSourceDS} compID='reportViewer' Project_ID={9} Report_ID={1} saveSource={saveSourceDS} />
                        </div>
                    </React.Fragment >
                );
            }
        }
        catch (e) {
            console.error('Error loading Data Source Report Component: ', e);
            return (loading);
        }
    }
}

export default AddDataSource;